/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ coach: NonNullable<unknown>, time: NonNullable<unknown> }} Features_Hero_Chip_BookedInputs */

const en_features_hero_chip_booked = /** @type {(inputs: Features_Hero_Chip_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Booked: ${i?.coach}, ${i?.time}`)
};

const pl_features_hero_chip_booked = /** @type {(inputs: Features_Hero_Chip_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zarezerwowane: ${i?.coach}, ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Booked: {coach}, {time}" |
*
* @param {Features_Hero_Chip_BookedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_chip_booked = /** @type {((inputs: Features_Hero_Chip_BookedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_Chip_BookedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_chip_booked(inputs)
	return en_features_hero_chip_booked(inputs)
});